/* Care FAQ rows (v52d) + open-row highlight for EVERY FAQ row.
   1) Two extra care questions cloned from the existing accordion.
   2) Any open FAQ row gets a soft orange card.
   3) "What is your return policy?" is removed from the FAQ (it lives in the
      footer under Returns & refunds / Refund policy). */
(function(){
var QA=[
['How do I wash and dry it?','Machine wash cold on a gentle cycle, inside out. No bleach, no fabric softener (it clogs the knit and kills breathability). Hang or lay flat to dry. Never tumble dry or iron.'],
['Will it fog my goggles or get wet from my breath?','Tuck the mask under the goggle foam, not over it, so your breath leaves through the knit instead of rising into the lens. On long lift rides, pull the mouth down for a minute to let moisture out, and carry it in a dry pocket.']
];
var HIDE=/return policy/i;
var css=document.createElement('style');
css.textContent='#if-faqs > div{transition:background-color .25s ease,padding .25s ease,border-radius .25s ease,box-shadow .25s ease}'+
'#if-faqs > div.if-faq-open{background:#FFF3EE;border-radius:14px;padding-left:16px!important;padding-right:16px!important;border-bottom-color:transparent!important;box-shadow:inset 3px 0 0 #FF4D14;margin:4px 0}'+
'#if-faqs > div.if-faq-open button span:first-child{color:#C43100!important}'+
'#if-faqs > div.if-faq-open p{color:#3F4954!important}'+
'#if-faqs > div[data-if-faq-hide]{display:none!important}';
document.head.appendChild(css);
function hide(){var f=document.getElementById('if-faqs');if(!f)return;[].forEach.call(f.children,function(row){if(row.hasAttribute('data-if-faq-hide'))return;var b=row.querySelector('button');if(b&&HIDE.test(b.textContent||''))row.setAttribute('data-if-faq-hide','1');});}
function paint(){var f=document.getElementById('if-faqs');if(!f)return;hide();[].forEach.call(f.children,function(row){var p=row.querySelector('p');if(!p)return;var open=p.style.display!=='none'&&getComputedStyle(p).display!=='none';row.classList.toggle('if-faq-open',open);});}
function add(){
var f=document.getElementById('if-faqs');if(!f||f.querySelector('[data-if-care-faq]'))return false;
var items=f.children;if(!items.length)return false;
var sample=items[items.length-1];
if(!sample.querySelector('button')||!sample.querySelector('p'))return false;
QA.forEach(function(qa){
var d=sample.cloneNode(true);d.setAttribute('data-if-care-faq','1');d.removeAttribute('data-if-faq-hide');d.classList.remove('if-faq-open');
var old=d.querySelector('button');var nb=old.cloneNode(true);old.parentNode.replaceChild(nb,old);
var np=d.querySelector('p');
var spans=nb.querySelectorAll('span');
var lbl=spans[0]||nb, sign=spans.length>1?spans[spans.length-1]:null;
lbl.textContent=qa[0];np.textContent=qa[1];np.style.display='none';
if(sign)sign.innerHTML='+';
nb.setAttribute('aria-expanded','false');
nb.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();
var open=np.style.display!=='none';
np.style.display=open?'none':'block';
nb.setAttribute('aria-expanded',open?'false':'true');
if(sign)sign.innerHTML=open?'+':'&minus;';
paint();
});
f.appendChild(d);
});
paint();
return true;
}
document.addEventListener('click',function(e){if(e.target&&e.target.closest&&e.target.closest('#if-faqs'))setTimeout(paint,30);},true);
var n=0;var iv=setInterval(function(){n++;add();paint();if(n>60)clearInterval(iv);},200);
setInterval(paint,1200);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){add();paint();});else{add();paint();}
})();
